import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { DateTime } from 'luxon';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function capitalizeFirstLetter(text: string) {
  if (!text) return text; // Handle empty or undefined strings
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function getCurrentDate(dateOffset: number = 0, timezone: string = 'Europe/London'): string {
  const now = DateTime.now().setZone(timezone).plus({ days: dateOffset })
  return now.toFormat('yyyy-MM-dd')
}

export function formatTimeDifference(isoDateString: string, timezone: string = 'Europe/London'): { hours: number, minutes: number } {
  const givenDate = DateTime.fromISO(isoDateString, { zone: timezone })
  const now = DateTime.now().setZone(timezone)

  const difference = now.diff(givenDate, ['hours', 'minutes']).toObject()
  return {
    hours: Math.abs(Math.floor(difference.hours || 0)),
    minutes: Math.abs(Math.floor(difference.minutes || 0))
  }
}

export function getStatusClass(time: string, delayThresholds: [number, number], timezone: string): string {
  const now = DateTime.now().setZone(timezone)
  const eventTime = DateTime.fromISO(time, { zone: timezone })
  const hoursDifference = Math.abs(now.diff(eventTime, 'hours').hours)
  if (hoursDifference > delayThresholds[1]) return 'text-red-500 font-medium'
  if (hoursDifference > delayThresholds[0]) return 'text-yellow-500 font-medium'
  return 'text-gray-800 font-medium'
}

export function getIconStatusClass(time: string, delayThresholds: [number, number], timezone: string): string {
  const now = DateTime.now().setZone(timezone)
  const eventTime = DateTime.fromISO(time, { zone: timezone })
  const hoursDifference = Math.abs(now.diff(eventTime, 'hours').hours)
  if (hoursDifference > delayThresholds[1]) return 'text-red-500 text-2xl'
  if (hoursDifference > delayThresholds[0]) return 'text-yellow-500 text-2xl'
  return 'text-green-500 text-2xl'
}

export function debugModeActive() {
  return localStorage.getItem('debug') == '1'
}